// extracted by mini-css-extract-plugin
export default {"styles":"AdditionalPageSideNav_styles__E2NEj","placeHolderShimmer":"AdditionalPageSideNav_placeHolderShimmer__0dBnO"};